import { useMutation } from "@apollo/client";

import { parseDateToString } from "~/modules/app/util/dateHelpers";

import { MapEditorObservationPanelObservationFragment } from "./fragments.generated";
import { MapEditorObservationPanel_EcologicalFunctionCreateDocument } from "./mutations.generated";

export function useCreateEcologicalFunctionMutation() {
    const [mutate, result] = useMutation(MapEditorObservationPanel_EcologicalFunctionCreateDocument);

    const createEcologicalFunction = (
        observation: MapEditorObservationPanelObservationFragment,
        ecologicalFunctionTypeId: string,
    ) =>
        mutate({
            variables: {
                input: {
                    ecologicalFunctionTypeId,
                    geometry: observation.feature.geometry,
                    projectId: observation.projectId,
                    speciesIds: [observation.speciesId],
                    researchTypeId: observation.researchType.id,
                    preciseLocation: observation.preciseLocation,
                    answers: observation.answers ?? {},
                    reportId: observation.reportId,
                    plannerVisitId: observation.plannerVisitId,
                    linkedObservationId: observation.id,
                    createdAt: parseDateToString(new Date()),
                },
            },
        });

    return [createEcologicalFunction, result] as const;
}
